<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column class="pa-4">
                <v-breadcrumbs class=" pl-0">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout row wrap align-center
                          justify-space-between mb-4
                >
                    <v-flex sm6 xs12>
                        <h1 class="section-title-main my-3 font-weight-regular">{{$t("Живая лента")}}</h1>
                    </v-flex>
                    <v-flex sm6 xs12>
                        <inputIcon v-model="news_search" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-center
                          justify-space-between class='mb-3'
                >
                    <v-flex md8>
                        <liveNewsBlock v-for="(item, i) in paginated" :key="i" :content="item" />
                        <v-layout v-if="live_news.length > 10" justify-space-between align-center
                                  wrap
                                  class="mt-5"
                        >
                            <v-flex md5 sm7 xs12
                                    mb-4
                            >
                                <div class="text-xs-center">
                                    <v-pagination
                                        v-model="page"
                                        :length="Math.ceil(live_news.length / selected_number)"
                                        :total-visible="$vuetify.breakpoint.xs ? 4 : 5"
                                        prev-icon="arrow_back_ios"
                                        next-icon="arrow_forward_ios"
                                    />
                                </div>
                            </v-flex>
                            <v-flex md4 sm5 xs12
                                    mb-4
                            >
                                <v-select
                                    :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                                    : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                                    solo
                                    append-icon=""
                                    :label="$t('Показывать по 10')"
                                    class="input"
                                    @change="show_number($event, 10)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonRed   from '@/components/ui/buttons/button_red';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import liveNewsBlock from '@/components/view_blocks/Live_news/Live_news_block';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    buttonRed,
    inputIcon,
    liveNewsBlock,
  },
  computed: {
    ...mapGetters('live_news', [
      'live_news',
      'paginated',
      'selected_page',
      'selected_number',
      'search_string',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    news_search: {
      get() {
        return this.search_string;
      },
      set($event) {
        return this.SEARCH_STRING($event.target.value);
      },
    },
  },
  mounted() {
    this.get_live_news();
  },
  methods: {
    ...mapMutations('live_news', [
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SEARCH_STRING',
    ]),
    ...mapActions('live_news', [
      'show_number',
      'get_live_news',
    ]),
  },
};
</script>
